import { render, staticRenderFns } from "./commune-request-pending.vue?vue&type=template&id=72202491"
import script from "./commune-request-pending.vue?vue&type=script&lang=js"
export * from "./commune-request-pending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports